import { useEffect, useState } from 'react'

const UiCurrrencyInput = ({ value, onChange }) => {
  const numberFormat = new Intl.NumberFormat('ru-RU')
  const [focus, setFocus] = useState(false)
  const [localValue, setLocalValue] = useState(value?.toString())

  useEffect(() => {
    if (focus) {
      setLocalValue(value?.toString())
    } else {
      //setLocalValue(numberFormat.format(value?.toString())+" ₽")
      setLocalValue(numberFormat.format(value?.toString()))
    }
  }, [focus, value])

  return (
    <input
      className='cn-in'
      value={localValue}
      onFocus={() => setFocus(true)}
      onBlur={e => {
        const v = parseInt(e.target.value.replace(/[^+\d]/g, ''))
        onChange(isNaN(v) ? 0 : v)
        setFocus(false)
      }}
      onChange={e => setLocalValue(e.target.value)}
    />
  )
}

export default UiCurrrencyInput